"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPFS_HTTP_GATEWAY = exports.NFT_STORAGE_TOKEN = exports.DEFAULT_PORTRAITS = void 0;
exports.DEFAULT_PORTRAITS = {
    male_human: "assets/images/male_human.jpeg",
    male_elf: "assets/images/male_elf.jpeg",
    male_orc: "assets/images/male_orc.jpeg",
    female_human: "assets/images/female_human.jpeg",
    female_elf: "assets/images/female_elf.jpeg",
    female_drow: "assets/images/female_drow.jpeg",
};
exports.NFT_STORAGE_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweEI1MjdjM2I2ZjU2NzUwRTdmNDlBMUFlNmI3YjZEMjc4NTExNjg1OUEiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY5NjY0NDgyMTA2NCwibmFtZSI6ImNocmlzdG1hcyJ9.eSSMQhL-xDrtkIDVzEcxOm2faE3HdzENXfZPGGR9KPo";
exports.IPFS_HTTP_GATEWAY = "ipfs.io";
